<template>
  <div class="tw-h-65 tw-px-3 tw-py-1.5 tw-whitespace-nowrap tw-text-xs tw-rounded">
<!--    <font-awesome-icon :icon="icon" class="tw-mr-1" />-->
    <span>
      {{ label }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: [String, Array],
      // required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>
